
import httpClient from "@/plugins/axios";
import { JsonWebTokenError } from "jsonwebtoken";

export const getFeedbackCategories = async () => {
    const response = await httpClient.get("/v1/feedback/categories/");
    return response;
}

export const saveFeedback = async (feedback) => {
    // const formData = new FormData();
    // formData.append("feedback", feedback.feedback);
    // formData.append("require_answer", feedback.require_answer);
    // formData.append("answer_to", feedback.answer_to);
    // if (feedback.category)
    //     formData.append('category', feedback.category);

    // if (feedback.attachment && feedback.attachment_name) {
    //     formData.append('attachment', feedback.attachment);
    //     formData.append('attachment_name', feedback.attachment_name);
    // }

    const response = await httpClient.post("/v2/feedback/", feedback);
    return response;
}

export const saveFeedbackAttachment = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('attachment_name', file.name);

    const response = await httpClient.post("/v2/feedback/attachments/", formData);
    return response;
}

export const deleteFeedbackAttachment = async (id) => {
    const response = await httpClient.delete(`/v2/feedback/attachments/${id}/`);
    return response;
}

export const getFeedbackPolicy = async () => {
    const response = await httpClient.get("/v1/settings/feedback-policy/");
    return response;
}

export const getMyFeedbacks = async () => {
    const response = await httpClient.get("/v1/my/feedback");
    return response;
}

export const getMyFeedback = async (id) => {
    const response = await httpClient.get(`/v1/my/feedback/${id}`);
    return response;
}

export const saveMyFeedbackmessage = async (id, message) => {
    const response = await httpClient.post(`/v1/my/feedback/${id}/messages`,
        {
            feedback: id,
            text: message
        });
    return response;
}